import { CatToggle } from '@blocks-react/components/Toggle';
import { MyEquipmentToggleShareButtonProps } from '../types';
import styles from '../MyEquipment.module.scss';

export const MyEquipmentToggleShareButton = ({
  handleToggleChange,
  text,
  checked,
  classname
}: MyEquipmentToggleShareButtonProps) => {
  const labelClass = classname ?? styles['drawer-toggle-text'];
  return (
    <CatToggle
      checked={checked}
      onBlToggleChange={handleToggleChange}
      data-testid="toggle-change-id"
      label=""
    >
      <span slot="checked-label" className={labelClass}>
        {text}
      </span>
      <span slot="unchecked-label" className={labelClass}>
        {text}
      </span>
    </CatToggle>
  );
};
